<app-labeled-card>
  <div class="accordion-header" (click)="toggleAccordion()">
    <div class="text">
      <div class="title">{{ title }}</div>
      @if(adminOnly){
      <div style="color: var(--nt-red); font-weight: 600">Admin</div>
      }
    </div>
    <i class="pi pi-chevron-down" [@rotate]="visible ? 'rotated' : 'default'"></i>
  </div>
  <div [@verticalSlideToggle]="visible ? 'open' : 'closed'">
    <ng-content></ng-content>
  </div>
</app-labeled-card>
